/**
 * 运营 - 消息通知管理
 */
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/oms/customerSignOrder' }">签单管理</el-breadcrumb-item>
      <el-breadcrumb-item>消息通知</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="search-card" shadow="never" style="margin-top: 16px">
      <div class="toolbar">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openDialog()">新增</el-button>
      </div>

      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中"
        style="width: 100%; margin-top: 16px"
        border
      >
        <el-table-column prop="title" label="标题" min-width="140" show-overflow-tooltip />
        <el-table-column prop="distributeCompanyName" label="服务商名称" min-width="120" show-overflow-tooltip />
        <el-table-column prop="content" label="内容摘要" min-width="200">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.content || '暂无内容'" placement="top">
              <span>{{ (scope.row.content || '').slice(0, 50) }}{{ (scope.row.content || '').length > 50 ? '...' : '' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createdDate" label="发布日期" width="120" show-overflow-tooltip />
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="openDialog(scope.row)">修改</el-button>
            <el-button type="danger" size="small" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <Pagination v-bind:child-msg="pageparm" @callFather="callFather" />
    </el-card>

    <el-dialog
      :title="form.id ? '修改消息' : '新增消息'"
      :visible.sync="dialogVisible"
      width="560px"
      @close="resetForm"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="服务商" prop="distributeCompanyIds">
          <el-select
            v-model="form.distributeCompanyIds"
            multiple
            filterable
            clearable
            placeholder="请选择服务商（可不选）"
            style="width: 100%"
          >
            <el-option
              v-for="item in serviceProviderList"
              :key="item.id != null ? item.id : item.value"
              :label="item.label || item.name"
              :value="item.id != null ? item.id : (item.value != null ? item.value : item.label)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题" maxlength="100" show-word-limit clearable />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            v-model="form.content"
            type="textarea"
            :rows="6"
            placeholder="请输入消息内容"
            maxlength="2000"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getNoticeManageList,
  createNotice,
  updateNotice,
  deleteNotice,
  getDisCompanyNames
} from '../../api/userMG';
import Pagination from '../../components/Pagination';

export default {
  name: 'NoticeManage',
  components: { Pagination },
  data() {
    return {
      loading: false,
      submitLoading: false,
      dialogVisible: false,
      listData: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      form: {
        id: null,
        title: '',
        content: '',
        distributeCompanyIds: []
      },
      serviceProviderList: [],
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      }
    };
  },
  created() {
    this.fetchList();
    this.fetchServiceProviderList();
  },
  methods: {
    fetchList() {
      this.loading = true;
      getNoticeManageList({
        page: this.pageparm.page,
        pageSize: this.pageparm.pageSize
      })
        .then((res) => {
          if (res.msg === 'success' && res.data) {
            const data = res.data;
            this.listData = data.items || data.list || [];
            this.pageparm.total = data.totalCount != null ? data.totalCount : (data.total || 0);
          } else {
            this.listData = [];
          }
        })
        .catch(() => {
          this.listData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    callFather(parm) {
      this.pageparm.page = parm.page;
      this.pageparm.pageSize = parm.pageSize;
      this.fetchList();
    },
    fetchServiceProviderList() {
      getDisCompanyNames({ page: 1, pageSize: 9999, type: 2 })
        .then((res) => {
          if (res.msg === 'success' && res.data) {
            const raw = res.data.items || res.data.list || res.data;
            this.serviceProviderList = Array.isArray(raw) ? raw : [];
          }
        })
        .catch(() => {});
    },
    openDialog(row) {
      if (row && row.id) {
        this.form.id = row.id;
        this.form.title = row.title || '';
        this.form.content = row.content || '';
        const companyId = row.distributeCompanyId;
        if (companyId === 0 || companyId === '0') {
          this.form.distributeCompanyIds = [];
        } else {
          this.form.distributeCompanyIds = (row.distributeCompanyIds && row.distributeCompanyIds.slice()) || (row.distributeCompanyId != null ? [row.distributeCompanyId] : []);
        }
      } else {
        this.form.id = null;
        this.form.title = '';
        this.form.content = '';
        this.form.distributeCompanyIds = [];
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    resetForm() {
      this.form.id = null;
      this.form.title = '';
      this.form.content = '';
      this.$refs.formRef && this.$refs.formRef.resetFields();
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        const isEdit = !!this.form.id;
        const payload = {
          title: this.form.title,
          content: this.form.content
        };
        if (isEdit) {
          // 修改：只传单个服务商 id
          payload.distributeCompanyId = this.form.distributeCompanyIds && this.form.distributeCompanyIds.length ? this.form.distributeCompanyIds[0] : undefined;
        } else {
          // 新增：传多个服务商 id
          payload.distributeCompanyIds = (this.form.distributeCompanyIds && this.form.distributeCompanyIds.length) ? this.form.distributeCompanyIds : undefined;
        }
        const promise = isEdit
          ? updateNotice(this.form.id, payload)
          : createNotice(payload);
        promise
          .then((res) => {
            if (res.msg === 'success' || res.code === 0) {
              this.$message.success(this.form.id ? '修改成功' : '新增成功');
              this.dialogVisible = false;
              this.fetchList();
            } else {
              this.$message.error(res.msg || '操作失败');
            }
          })
          .catch(() => {
            this.$message.error('操作失败');
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    handleDelete(row) {
      this.$confirm('确定删除该消息吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          return deleteNotice(row.id);
        })
        .then((res) => {
          if (res.msg === 'success' || res.code === 0) {
            this.$message.success('删除成功');
            this.fetchList();
          } else {
            this.$message.error(res.msg || '删除失败');
          }
        })
        .catch((err) => {
          if (err !== 'cancel') this.$message.error('删除失败');
        });
    }
  }
};
</script>

<style scoped>
.toolbar {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/noticeManage.vue